module.exports = __webpack_public_path__ + "static/img/2.2becac3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/eng/2.png
// module id = 0jqI
// module chunks = 0